import {
  Card,
  SpaceBetween,
  TextElement,
  borderRadius,
  spacing,
  styled,
  useTranslation,
} from '@lessonup/ui-components';
import { getRouteForAsset } from '@lessonup/utils';
import React, { useState } from 'react';
import { TRANSLATION_NAMESPACE } from '../constantsV2';
import { Footer } from './Footer';
import { LessonModalMainWrapper } from './LayoutComponents';

interface ChooseEditorProps {
  onSelect: (editor: 'classic' | 'new') => void;
}

export const ChooseEditor: React.FC<ChooseEditorProps> = ({ onSelect }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE, { keyPrefix: 'chooseEditor' });
  const [selectedEditor, setSelectedEditor] = useState<'classic' | 'new'>();

  return (
    <StyledLessonModalMainWrapper>
      <StyledSpaceBetween direction="y" spacing={spacing.size8}>
        <Card resizing="fixed" active={selectedEditor === 'new'} onClick={() => setSelectedEditor('new')}>
          <SpaceBetween direction="x" spacing={spacing.size8}>
            <StyledText>
              <TextElement textStyle="bodyTextLarge" as="h2" size="small" weight="bold">
                {t('newEditorTitle')}
              </TextElement>
              <TextElement textStyle="bodyText" size="small">
                {t('newEditorDescription')}
              </TextElement>
            </StyledText>
            <StyledImage src={getRouteForAsset('img/CreateLessonModal/classic-editor.png')} />
          </SpaceBetween>
        </Card>
        <Card resizing="fixed" active={selectedEditor === 'classic'} onClick={() => setSelectedEditor('classic')}>
          <SpaceBetween direction="x" spacing={spacing.size8}>
            <StyledText>
              <TextElement textStyle="bodyTextLarge" as="h2" size="small" weight="bold">
                {t('classicEditorTitle')}
              </TextElement>
              <TextElement textStyle="bodyText" size="small">
                {t('classicEditorDescription')}
              </TextElement>
            </StyledText>
            <StyledImage src={getRouteForAsset('img/CreateLessonModal/new-editor.png')} />
          </SpaceBetween>
        </Card>
      </StyledSpaceBetween>
      <Footer
        nextButton={{
          onClick: () => selectedEditor && onSelect(selectedEditor),
          label: t('continue'),
          disabled: !selectedEditor,
        }}
      />
    </StyledLessonModalMainWrapper>
  );
};

const StyledSpaceBetween = styled(SpaceBetween)`
  margin: ${spacing.size16};
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
`;

const StyledText = styled.div`
  width: 50%;
  margin: ${spacing.size16};
`;

const StyledImage = styled.div<{ src: string }>`
  background-image: url(${(props) => props.src});
  width: 50%;
  height: 0;
  padding-top: 25%;
  margin: ${spacing.size16};
  border-radius: ${borderRadius.rounded8};
  background-size: cover;
  background-position: center;
`;

const StyledLessonModalMainWrapper = styled(LessonModalMainWrapper)`
  padding: ${spacing.size16};
`;
